// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'notepad-empty-solid';

export const Component = () => (
  <path d='M20.666 3.448v1.437H4V3.448c0-.43.144-.766.431-1.053a1.408 1.408 0 0 1 1.054-.432h1.437V.48c0-.335.191-.479.526-.479.336 0 .48.144.48.479v1.484h3.927V.48c0-.335.143-.479.479-.479.335 0 .479.144.479.479v1.484h3.927V.48c0-.335.144-.479.479-.479.335 0 .526.144.526.479v1.484h1.437c.431 0 .766.144 1.054.432.287.287.431.622.431 1.053ZM4 5.891v17.145c0 .431.144.766.431 1.054.288.287.623.431 1.054.431h13.698c.431 0 .766-.144 1.054-.431.287-.288.431-.623.431-1.054V5.89H4Z' />
);

export const viewBox = '0 0 25 25';
